import axios from 'axios';
import { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { ParentParams, Setting } from '../types/constant/PagesPropsType';
import { ChangeDeliveryAddress } from '../components/SubscriptionDetail/ChangeDeliveryAddress';
import { ChangeDeliveryDateModal } from '../components/ChangeDeliveryDateModal/ChangeDeliveryDateModal';
import { ChangePaymentMethod } from '../components/SubscriptionDetail/ChangePaymentMethod';
import { Coupon } from '../components/SubscriptionDetail/Coupon';
import { ConfirmModal } from '../components/ConfirmModal/ConfirmModal';
import { LoadingModal } from '../components/LoadingModal/LoadingModal';
import { AfterUpdateMessageModal } from '../components/MessageModal/AfterUpdateMessageModal';
import { MessageModal } from '../components/MessageModal/MessageModal';
import { SkipModal } from '../components/SkipModal/SkipModal';
import { BackBtn } from '../components/SubscriptionDetail/BackBtn';
import { CancelPauseLink } from '../components/SubscriptionDetail/CancelPauseLink';
import { PauseLink } from '../components/SubscriptionDetail/PauseLink';
import { PageTitle } from '../components/SubscriptionDetail/PageTitle';
import { ProductDescModal } from '../components/ProductDescModal/ProductDescModal';
import { NewOrderModal } from '../components/NewOrderModal/NewOrderModal';
import { Summary } from '../components/SubscriptionDetail/Summary';
import { TermsOfService } from '../components/SubscriptionDetail/TermsOfService';
import { TermsOfServiceModal } from '../components/TermsOfServiceModal/TermsOfServiceModal';
import { useApplyCoupon } from '../hooks/use-apply-coupon';
import { useNewOrder } from '../hooks/use-new-order';
import { usePaymentMethodUpdate } from '../hooks/use-payment-method-update';
import { useSubscriptionDetail } from '../hooks/use-subscription-detail';
import { useUpdateDeliveryAddress } from '../hooks/use-update-delivery-address';
import { useUpdateNextDeliveryDate } from '../hooks/use-update-next-delivery-date';
import { Billing, useUpdateSubscriptionLinePlan } from '../hooks/use-update-subscription-line-plan';
import { SubscriptionApiType } from '../types/api/SubscriptionApiType';
import { ConfirmModalViewType } from '../types/view/ConfirmModalViewType';
import { ChangeDeliveryAddressViewType } from '../types/view/ChangeDeliveryAddressViewType';
import { ChangeDeliveryDateModalViewType } from '../types/view/ChangeDeliveryDateModalViewType';
import {
  MessageModalViewType,
  NewOrderUpdateMessageModalViewType,
  UpdateMessageModalViewType,
} from '../types/view/MessageModalViewType';
import { ProductDescModalViewType } from '../types/view/ProductDescModalViewType';
import { SkipModalViewType } from '../types/view/SkipModalViewType';
import { SummaryViewType } from '../types/view/SummaryViewType';
import { TermsOfServiceModalViewType } from '../types/view/TermsOfServiceModalViewType';
import '../assets/css/style.css';
import { CUSTOMER_API_URL, modelChangeDate } from '../constants';
import dayjs from 'dayjs';
import { NewOrderModalType } from '../types/view/NewOrderModalType';
import { createSummary } from '../utils/createSummary';
import { createChangeDeliveryDateModal } from '../utils/createChangeDeliveryDateModal';
import { reflectValueToChangeDeliveryAddress } from '../utils/reflectValueToChangeDeliveryAddress';
import { setNewOrderErrorMessage } from '../utils/formats';
import {
  RecProducts,
  useUpdateSubscriptionProducts,
} from '../hooks/use-update-subscription-products';
import { RecommendedSetModal } from '../components/RecommendedSetModal/RecommendedSetModal';
import { CountdownProgressModal } from '../components/CountdownProgressModal/CountdownProgressModal';
import { NewOrderUpdateMessageModal } from '../components/MessageModal/NewOrderUpdateMessageModal';
import { ChangeDeliveryIntervalModal } from '../components/ChangeDeliveryDateModal/ChangeDeliveryIntervalModal';
import { useDetectBrowserBack } from '../hooks/use-detected-back';
import { postMessageGtag } from '../utils/trackClick';
import { ConfirmVariantsDirtyModal } from '../components/ConfirmModal/ConfirmVariantsDirtyModal';
import { CancellationSectionModal } from '../components/TermsOfServiceModal/CancellationSectionModal';
import { useMasterContext } from '../context';
import { useSubscriptionProducts } from '../hooks/use-subscription-products';
import {
  NextDeliveryDisplayState,
  NextDeliverySubscription,
} from '../components/SubscriptionDetail/NextDeliverySubscription/NextDeliverySubscription';
import { DiffState } from '../hooks/use-product-cart';
import { boxMinQuantitiesSatisfiedForLines } from '../utils/boxSettings';
import {
  buildUpdateSubscriptionV2PostBodyFromDiff,
  isEmptyUpdateSubscriptionV2PostBody,
} from '../utils/subscriptionDetail/buildUpdateSubscriptionV2PostBody';
import { fetchSubscriptionContract } from '../utils/subscriptionDetail/fetchSubscriptionContract';
import { applyUpdateSubscriptionV2PostBodyToLines } from '../utils/subscriptionDetail/simulatePostBodyLines';
import { verifyCreatesAgainstAlternativeProducts } from '../utils/subscriptionDetail/verifyCreatesAgainstAlternativeProducts';
import { resize } from '../utils/postMessage';
import {
  checkYuPack,
  getBorderPrice,
  initialSetTotal,
  isYuPack,
} from '../utils/subscriptionDetail/utils';

export const SubscriptionDetail: FC<{
  setting: Setting;
  parentParams: ParentParams;
}> = ({ setting, parentParams }) => {
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  const history = useHistory();
  // 定期購買詳細画面のデータ
  const [summary, setSummary] = useState<SummaryViewType>();
  const [cancelPauseInfo, setCancelPauseInfo] = useState({});

  // お届け予定日変更モーダルのデータ
  const [changeDeliveryDateModal, setChangeDeliveryDateModal] =
    useState<ChangeDeliveryDateModalViewType | null>(null);
  // お届け周期変更モーダルのデータ
  const [changeDeliveryIntervalModal, setChangeDeliveryIntervalModal] = useState<Billing[] | null>(
    null
  );
  // お届け先変更のデータ
  const [changeDeliveryAddress, setChangeDeliveryAddress] =
    useState<ChangeDeliveryAddressViewType | null>(null);
  // メッセージモーダルのデータ
  const [messageModal, setMessageModal] = useState<MessageModalViewType | null>(null);
  // 更新処理後に表示するモーダル
  const [updateMessageModal, setUpdateMessageModal] = useState<UpdateMessageModalViewType | null>(
    null
  );
  // 定期詳細APIリロードフラグ
  const [reloadFlg, setReloadFlg] = useState(false);
  // スキップモーダル
  const [skipModal, setSkipModal] = useState<SkipModalViewType | null>(null);
  //レコメンドセットフラグ
  const [showRecommendedSet, setShowRecommendedSet] = useState<boolean>(false);
  // 利用規約モーダルのデータ
  const [termsOfServiceModal, setTermsOfServiceModal] =
    useState<TermsOfServiceModalViewType | null>(null);
  const [cancellationSectionModal, setCancellationSectionModal] = useState(false);
  // 商品説明モーダル
  const [productDescModal, setProductDescModal] = useState<ProductDescModalViewType | null>(null);
  // 最短でお届けモーダル
  const [newOrderModal, setNewOrderModal] = useState<NewOrderModalType | null>(null);
  // 確認モーダル
  const [confirmModal, setConfirmModal] = useState<ConfirmModalViewType | null>(null);
  // 最短でお届け更新後モーダル
  const [newOrderUpdateMessageModal, setNewOrderUpdateMessageModal] =
    useState<NewOrderUpdateMessageModalViewType | null>(null);

  // リクエスト中に別のリクエストを飛ばさないためのフラグ
  const [loading, setLoading] = useState(false);
  // 特に時間がかかるリクエストのときのフラグ
  const [heavyLoading, setHeavyLoading] = useState(false);
  // クーポン適用のデータ
  const [coupon, setCoupon] = useState('');
  const [thanksmileCoupons, setThanksmileCoupons] = useState<{ title: string; code: string }[]>([]);

  //今すぐ注文とカウントダウン表示
  const [showCountdownProgress, setShowCountdownProgress] = useState(false);
  const [nextDeliveryDateAfterOrder, setNextDeliveryDateAfterOrder] = useState<string | null>(null);

  // モーダル遷移元を記録する状態
  const [modalOrigin, setModalOrigin] = useState<'skip' | 'pause' | null>(null);
  const [returnToPauseModal, setReturnToPauseModal] = useState(false);

  // 商品編集中の確認モーダル
  const [isVariantsChanged, setIsVariantsChanged] = useState(false);
  const [isVariantsDirty, setIsVariantsDirty] = useState(false);
  // 次回お届けの変更がサーバー保存に成功したら増やし、子で diff をリセットする
  const [variantsSaveSuccessKey, setVariantsSaveSuccessKey] = useState(0);
  // 次回お届け内容の手動再読み込みをトリガーするキー
  const [nextDeliveryReloadKey, setNextDeliveryReloadKey] = useState(0);
  // 取得待ちが長引いたとき「再読み込み」導線を表示するフラグ
  const [isNextDeliveryStalled, setIsNextDeliveryStalled] = useState(false);

  // 画面内でリクエストするAPI一覧
  const { subscription, setSubscription, fetchSubscription, subscriptionFetchStatus } =
    useSubscriptionDetail(setting, id);
  const { boxSettings } = useMasterContext();
  const {
    subscribableProducts,
    subscribedProducts,
    products,
    planGroups,
  } = useSubscriptionProducts(subscription, parentParams, setting.token, nextDeliveryReloadKey);
  const { updateSubscriptionLinePlan, getChangeableCycles } = useUpdateSubscriptionLinePlan();
  const { updateDeliveryDays, validUpdateDeliveryDays } = useUpdateNextDeliveryDate();
  const { paymentMethodUpdate } = usePaymentMethodUpdate();
  const { updateDeliveryAddress } = useUpdateDeliveryAddress();
  const { applyCoupon } = useApplyCoupon();
  const { newOrder } = useNewOrder();
  const { updateSubscriptionProducts } = useUpdateSubscriptionProducts();

  // ブラウザバック
  useDetectBrowserBack();

  // getSubscription が失敗した、または契約IDが欠損（メンテで空 JSON 等）のときはマイアカトップへ
  useEffect(() => {
    if (subscriptionFetchStatus === 'error') {
      history.replace('/');
    }
  }, [subscriptionFetchStatus, history]);

  // 定期購買情報が更新される度に呼び出される
  useEffect(() => {
    if (!subscription) return;

    // アクティブ以外（一時停止・解約など）の場合はマイアカウント画面へリダイレクト
    if (subscription.status !== 'ACTIVE') {
      history.replace('/');
      return;
    }

    setSummary(createSummary(subscription));

    // 解約できる状況か（最低購入回数を満たしているか）
    // 定期購買詳細取得APIに初回請求情報は含まれていないためcountは1から始める
    let count = 1;
    subscription.billingAttempts.forEach((atmpt) => {
      if (atmpt.orderId !== null && atmpt.ready === true) {
        count++;
      }
    });
    if (subscription.billingPolicyMinCycles <= count) {
      setCancelPauseInfo({ canCancelPause: true });
    } else {
      setCancelPauseInfo({
        canCancelPause: false,
        minCycle: subscription.billingPolicyMinCycles,
      });
    }

    // 配送先住所変更用
    setChangeDeliveryAddress({
      ...subscription!,
    });

    // クーポン用
    const firstCoupon = subscription.subscriptionDiscounts.find(
      (discount) => discount.coupon === true
    );
    if (firstCoupon) {
      setCoupon(firstCoupon.title);
    }
  }, [subscription]);

  // iframeの高さ調整
  const root = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!subscribedProducts || !subscribableProducts || !root.current) return;
    resize(root.current.clientHeight);
  }, [subscribableProducts, subscribedProducts]);

  const changeDeliveryAddressFunc = useCallback((name: string, value: string) => {
    setChangeDeliveryAddress((prev) => reflectValueToChangeDeliveryAddress(prev!, name, value));
  }, []);

  // 時間設定リセット
  const resetDeliveryTime = useCallback(
    (completeFunc: () => void) => {
      if (!subscription) return;
      const changeDeliveryDate = createChangeDeliveryDateModal(subscription);

      // 時間設定なしに更新
      updateDeliveryDays(
        setting,
        subscription,
        {
          ...changeDeliveryDate,
          deliveryTime: '', //時間設定なし
        },
        (nextBillingDate, nextDeliveryDate, deliveryDays, deliveryTime, deliveryTimeText) => {
          setSubscription({
            ...subscription,
            nextBillingDate,
            nextDeliveryDate,
            deliveryDays,
            deliveryTime,
            deliveryTimeText,
          });
        },
        () => {
          console.error('Failed to update next delivery date');
        },
        () => {
          completeFunc();
        }
      );
    },
    [setting, subscription, setSubscription, updateDeliveryDays]
  );

  // 最短お届け後に次回お届け日を更新する関数
  const updateNextDeliveryDateAfterNewOrder = (
    subscription: SubscriptionApiType,
    nextDeliveryDate: string,
    success: () => void,
    failed: (error?: any) => void
  ) => {
    const changeDeliveryDate = createChangeDeliveryDateModal(subscription!);

    // 現在と同じ設定で更新するとAPI失敗となることを考慮
    if (dayjs(changeDeliveryDate.nextDeliveryDate).format('YYYY/MM/DD') !== nextDeliveryDate) {
      // updateDeliveryDays APIを使って次回お届け日を更新
      updateDeliveryDays(
        setting,
        subscription,
        {
          ...changeDeliveryDate,
          nextDeliveryDate: dayjs(nextDeliveryDate, 'YYYY/MM/DD').toDate(),
        },

        (nextBillingDate, nextDeliveryDate, deliveryDays, deliveryTime, deliveryTimeText) => {
          // 更新成功時：subscriptionを更新
          setSubscription({
            ...subscription,
            nextBillingDate,
            nextDeliveryDate,
            deliveryDays,
            deliveryTime,
            deliveryTimeText,
          });
          success();
        },
        () => {
          // 更新失敗時
          console.error('Failed to update next delivery date');
          failed();
        },
        () => {
          // 完了時の処理（特に何もしない）
        }
      );
    } else {
      success();
    }
  };

  //今すぐ注文
  const handleNewOrder = () => {
    setLoading(true);
    setShowCountdownProgress(true); // カウントダウンモーダルを表示

    newOrder(
      setting,
      subscription!,
      (billingAttempt) => {
        // 成功したときの処理
        const updatedSubscription = {
          ...subscription!,
          billingAttempt: [billingAttempt, ...subscription!.billingAttempts],
        };
        setSubscription(updatedSubscription);

        setSubscription({
          ...subscription!,
          billingAttempts: [billingAttempt, ...subscription!.billingAttempts],
        });

        // 次回お届け日を計算して保存
        const nextDeliveryDate = calculateNextDeliveryDate(subscription!);
        setNextDeliveryDateAfterOrder(nextDeliveryDate);

        // isAfterProductUpdateの値を保持（これは既存のコード）
        const isAfterProductUpdateValue = newOrderModal?.isAfterProductUpdate;

        // カウントダウンが終わってから自動的にメッセージモーダルを表示するので、
        // ここではメッセージモーダルを表示しない
      },
      (responseStatus: number) => {
        // エラー時の処理
        setShowCountdownProgress(false);
        const errorMessage = setNewOrderErrorMessage(responseStatus);
        setMessageModal({
          title: errorMessage.title,
          message: errorMessage.message,
        });
        setLoading(false);
      },
      () => {
        // completion関数はAPIコールの終了時に呼ばれるが、
        // カウントダウンモーダルを表示している間はloadingをtrueのままにするため、
        // ここでは何もしない
      }
    );
  };

  //今すぐ注文後、次回お届け日を計算する関数
  const calculateNextDeliveryDate = (subscription: SubscriptionApiType): string => {
    const now = dayjs();
    let nextDate;

    if (subscription.billingPolicyInterval === 'DAY') {
      nextDate = now.add(subscription.billingPolicyIntervalCount, 'day');
    } else if (subscription.billingPolicyInterval === 'WEEK') {
      nextDate = now.add(subscription.billingPolicyIntervalCount * 7, 'day');
    } else if (subscription.billingPolicyInterval === 'MONTH') {
      nextDate = now.add(subscription.billingPolicyIntervalCount, 'month');
    } else {
      nextDate = now.add(subscription.billingPolicyIntervalCount, 'year');
    }

    return nextDate.format('YYYY/MM/DD');
  };

  //今すぐ注文時のカウントダウン完了時の処理
  const handleCountdownComplete = () => {
    // APIで次回お届け日を更新する処理を実行
    if (subscription && nextDeliveryDateAfterOrder) {
      // 次回お届け日を更新するAPIを呼び出し
      updateNextDeliveryDateAfterNewOrder(
        subscription,
        nextDeliveryDateAfterOrder,
        () => {
          // 成功時の処理
          setShowCountdownProgress(false);
          // カウントダウン完了時にloadingをfalseに設定
          setLoading(false);

          // カウントダウン完了後にメッセージモーダルを表示
          setNewOrderUpdateMessageModal({
            nextDeliveryDateStr: nextDeliveryDateAfterOrder,
            intervalCount: subscription.billingPolicyIntervalCount,
          });
        },
        () => {
          // エラー時の処理
          setShowCountdownProgress(false);
          setLoading(false);
          setNewOrderUpdateMessageModal({
            nextDeliveryDateStr: dayjs(summary?.nextDeliveryDate).format('YYYY/MM/DD'), // 次回お届け日と同様
            intervalCount: subscription.billingPolicyIntervalCount,
            clickDeliveryDateFunc: () => {
              setNewOrderUpdateMessageModal(null);
              const deliveryDateData = createChangeDeliveryDateModal(subscription!);
              setChangeDeliveryDateModal(deliveryDateData);
            },
          });
        }
      );
    } else {
      // subscriptionやnextDeliveryDateAfterOrderがない場合
      setShowCountdownProgress(false);
      setLoading(false);

      setMessageModal({
        title: '更新完了',
        message: '注文確定メールをお送りしました。\nお届けまでお待ちください。',
      });
    }
  };

  /** 定期便登録内容更新処理 ここまで＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝ */

  useEffect(() => {
    window.parent.postMessage({ action: 'subscriptionDetail' }, '*');

    const fetchThanksmileCoupons = (event: MessageEvent<any>) => {
      if (event.data.action && event.data.action === 'thanksmileCoupons') {
        setThanksmileCoupons(event.data.coupons);
      }
    };

    window.addEventListener('message', fetchThanksmileCoupons);

    return () => window.removeEventListener('message', fetchThanksmileCoupons);
  }, []);

  // 契約日がmodelChangeDate以前かどうか
  const createdDate = subscription && dayjs(subscription.createdAt);
  const modelChange = dayjs(modelChangeDate);
  const isBeforeModelChange = createdDate && createdDate.isBefore(modelChange) ? true : false;

  const handleOpenRecommendSet = (origin: 'skip' | 'pause') => {
    // 元のモーダルを記録
    setModalOrigin(origin);

    // 元のモーダルを閉じる
    if (origin === 'skip') {
      setSkipModal(null);
    } else {
      // pauseの場合は何もしない（PauseLink側で処理される）
    }

    // 商品セットモーダルを開く
    setTimeout(() => {
      setShowRecommendedSet(true);
    }, 100);
  };

  const handleBackToOriginalModal = () => {
    // 商品セットモーダルを閉じる
    setShowRecommendedSet(false);

    // 元のモーダルを再表示
    if (modalOrigin === 'skip') {
      setSkipModal({ isOpen: true });
    } else if (modalOrigin === 'pause') {
      // pauseの場合は特別な状態を設定
      setReturnToPauseModal(true);
    }

    // 記録をリセット
    setModalOrigin(null);
  };

  // 商品の一括変更処理
  const handleProductSetChange = (recProducts: RecProducts) => {
    setShowRecommendedSet(false);
    setLoading(true);
    setHeavyLoading(true);
    updateSubscriptionProducts(
      setting,
      subscription!,
      recProducts, // 商品とその数量のオブジェクトを直接渡す
      planGroups,
      products,
      (totalWeight) => {
        // 成功時の処理
        const completeFunc = () => {
          setUpdateMessageModal({
            isSuccess: true,
            showOrderLink: true,
          });
          setReloadFlg(true);
        };

        if (!isYuPack(totalWeight)) {
          resetDeliveryTime(completeFunc);
        } else {
          completeFunc();
        }
      },
      () => {
        // 失敗時の処理
        setUpdateMessageModal({
          isSuccess: false,
        });
        setReloadFlg(false);
      },
      () => {
        // 完了時の処理
        setHeavyLoading(false);
        setLoading(false);
      }
    );
  };

  // 最低金額、最大金額の計算
  const { maxBorderPrice, minBorderPrice } = getBorderPrice(parentParams.customerTags);
  // パラメータの取得
  const paramCategoryId = new URLSearchParams(search).get('categoryId') ?? '';
  // クーポンへのアンカーリンク判定
  const isCouponParam = paramCategoryId === 'coupon' ? true : false;
  const isCouponAnchorLink = Boolean(isCouponParam && subscribedProducts && subscribableProducts);

  useEffect(() => {
    if (!subscription) return;

    const { totalPrice, totalQuantity, discountPrice, showShippingCounter, isCalculating } =
      initialSetTotal(subscription);

    window.parent.postMessage(
      {
        action: 'setTotal',
        totalPrice: totalPrice.toLocaleString(),
        totalQuantity,
        // テーマ側では shippingPrice を「送料有無フラグ」として扱っている。
        // 1: カウンターを表示（到達時は「送料無料でお届け！」）
        // 0: カウンターを非表示
        shippingPrice: showShippingCounter ? 1 : 0,
        isCalculating,
        discountPrice,
      },
      '*'
    );
  }, [subscription]);

  // フッター「変更を完了」→ 次回お届けの変更をサーバーに保存する一連の処理
  const updateSubscription = useCallback(
    async (diff: DiffState, isTimeReset: boolean) => {
      // ① 必須データが揃っていなければ何もしない（このときは API も呼ばないのでネットワークに出ない）
      if (!subscription || !products || !setting.token || !subscribedProducts) {
        setMessageModal({
          message:
            '定期情報または商品情報を読み込めていません。画面を再読み込みしてから、もう一度お試しください。',
        });
        return;
      }

      // ② 送信直前に契約を再取得し、他タブ等で既に載った商品の「追加」差分を更新に寄せてから JSON を組み立てる
      const freshSubscription = await fetchSubscriptionContract(
        setting.token,
        subscription.subscriptionContractId
      );
      if (!freshSubscription) {
        setMessageModal({
          message:
            '最新の定期情報を取得できませんでした。画面を再読み込みしてから、もう一度お試しください。',
        });
        return;
      }

      const { postBody, createsForAlternativeVerify } = buildUpdateSubscriptionV2PostBodyFromDiff(
        products,
        diff,
        freshSubscription
      );
      if (isEmptyUpdateSubscriptionV2PostBody(postBody)) {
        setMessageModal({
          message:
            'サーバーに送れる商品変更がありません。追加した商品の詳細が取得できていない、または販売プラン情報が足りない可能性があります。画面を再読み込みするか、別の商品でお試しください。',
        });
        return;
      }

      // ②' 最新契約＋POST 適用後のラインで minQuantity を再検証（別タブで数量が動いたあと、ローカルだけ満たしていても破綻する場合）
      if (boxSettings && Object.keys(boxSettings).length > 0) {
        const simulated = applyUpdateSubscriptionV2PostBodyToLines(
          freshSubscription.subscriptionLines ?? [],
          postBody,
          products
        );
        if (!boxMinQuantitiesSatisfiedForLines(simulated, boxSettings)) {
          setMessageModal({
            title: '更新できませんでした',
            message: 'ページを更新して、\nもう一度お試しください。',
          });
          return;
        }
      }

      // ③ 通信中であることを画面に示す
      setLoading(true);
      setHeavyLoading(true);

      try {
        // ④ 真に追加ラインとして送る分だけ、変更可能商品 API で「載っていい商品か」を確認する
        if (createsForAlternativeVerify.length > 0) {
          const check = await verifyCreatesAgainstAlternativeProducts(
            setting.token,
            products,
            createsForAlternativeVerify
          );
          if (!check.ok) {
            setMessageModal({ message: check.message });
            return;
          }
        }

        // ⑥ 商品一括変更 API へ JSON を POST する
        await axios.post(`${CUSTOMER_API_URL}?action=updateSubscriptionV2`, postBody, {
          headers: { Authorization: setting.token },
        });

        // ⑦ 画面上の定期データを取り直す（リロードしない）
        // 保存後も「次回お届け内容」の再取得ローディングを必ず表示するため、
        // 商品/プラングループ取得キャッシュも同時に破棄して再取得を走らせる。
        setIsNextDeliveryStalled(false);
        setNextDeliveryReloadKey((prev) => prev + 1);
        fetchSubscription();

        // ⑧ 成功時にまとめて実行する処理（モーダル表示・親へ通知・カートの変更をクリア用のキー更新）
        const completeFunc = () => {
          setUpdateMessageModal({
            isSuccess: true,
            showOrderLink: true,
          });
          setVariantsSaveSuccessKey((k) => k + 1);
        };

        // ⑨ 配送の都合で「お届け時間をリセットする」必要があるときは先にそれを済ませてから ⑧ を実行
        if (isTimeReset && subscription.deliveryTime) {
          resetDeliveryTime(completeFunc);
        } else {
          completeFunc();
        }
      } catch (e) {
        // ⑩ ネットワークエラーや API エラー時（文言は MessageModal で固定表示）
        console.error(e);
        setMessageModal({
          title: '更新できませんでした',
          message: 'ページを更新して、\nもう一度お試しください。',
        });
        setReloadFlg(false);
      } finally {
        // ⑪ 成功・失敗どちらでもローディングを止める
        setHeavyLoading(false);
        setLoading(false);
      }
    },
    [
      subscription,
      products,
      setting.token,
      subscribedProducts,
      fetchSubscription,
      resetDeliveryTime,
      boxSettings,
    ]
  );

  const showConfirmMinPrice = useCallback((minPrice: number, handleUpdateFunc: () => void) => {
    setConfirmModal({
      message: `一度変更すると、\n<b>元のお届け内容には戻せなくなります。</b>\n\n商品の変更が自由にできる\nマイセレクトは、小計<b>¥${minPrice.toLocaleString()}</b>以上の\n組み合わせが必要です。\n\n変更しますか？`,
      btnTitle: '変更する',
      onClickFunc: () => handleUpdateFunc(),
    });
  }, []);

  const isDeliveryTimeSetting = checkYuPack(subscribedProducts);
  // 次回お届け内容に必要な行データが存在するか（0件契約はローディング対象外）。
  const hasSubscriptionLines = Boolean(subscription?.subscriptionLines?.length);
  // 必須データが揃い、NextDeliverySubscription を描画できる状態。
  const isNextDeliveryReady = Boolean(subscribedProducts && subscribableProducts);
  const nextDeliveryDisplayState: NextDeliveryDisplayState = isNextDeliveryReady
    ? 'ready'
    : isNextDeliveryStalled
      ? 'stalled'
      : 'loading';

  useEffect(() => {
    if (
      subscriptionFetchStatus !== 'success' ||
      !hasSubscriptionLines ||
      isNextDeliveryReady ||
      isNextDeliveryStalled
    ) {
      return;
    }

    // 必要データ不足が一定時間続くときは、手動再読み込み導線を表示する。（10秒）
    const timeoutId = window.setTimeout(() => {
      setIsNextDeliveryStalled(true);
    }, 10000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [
    hasSubscriptionLines,
    isNextDeliveryReady,
    isNextDeliveryStalled,
    subscriptionFetchStatus,
    nextDeliveryReloadKey,
  ]);

  useEffect(() => {
    if (isNextDeliveryReady) {
      setIsNextDeliveryStalled(false);
    }
  }, [isNextDeliveryReady]);

  // 再読み込みボタンは、契約APIの再取得＋商品/プラングループ再取得を同時に実行する。
  const retryNextDeliveryLoad = () => {
    setIsNextDeliveryStalled(false);
    setNextDeliveryReloadKey((prev) => prev + 1);
    fetchSubscription();
  };

  const openChangeIntervalModal = async () => {
    if (!subscription) return;
    const billing = await getChangeableCycles(setting.token, subscription.subscriptionContractId);
    if (!billing) {
      setMessageModal({
        message: '変更可能な周期がありません',
      });
    }

    setChangeDeliveryIntervalModal(billing);
  };

  return (
    <>
      <div
        className="container"
        ref={root}
      >
        <PageTitle
          clickBackBtnFunc={() => {
            if (isVariantsChanged) {
              setIsVariantsDirty(true);
              return;
            }
            postMessageGtag('click_back_to_top_header', 'detailSettings');
            history.push('/');
          }}
        />
        <div className="row">
          <div className="contentsLeft">
            <Summary
              summary={summary}
              isDeliveryTimeSetting={isDeliveryTimeSetting}
              clickDeliveryDateFunc={() => {
                const deliveryDateData = createChangeDeliveryDateModal(subscription!);
                setChangeDeliveryDateModal(deliveryDateData);
              }}
              clickDeliveryIntervalFunc={openChangeIntervalModal}
              clickSkipLinkFunc={() => {
                setSkipModal({ isOpen: true });
              }}
              clickNewOrderFunc={() => {
                setNewOrderModal({
                  isOpen: true,
                });
              }}
              loading={loading}
            />
          </div>
          <div className="contentsRight">
            {/* 次回お届け内容 */}
            <NextDeliverySubscription
              subscribableProducts={subscribableProducts}
              subscribedProducts={subscribedProducts}
              products={products}
              paramCategoryId={paramCategoryId}
              minBorderPrice={minBorderPrice}
              maxBorderPrice={maxBorderPrice}
              showConfirmMinPrice={showConfirmMinPrice}
              updateSubscription={updateSubscription}
              onEditChange={setIsVariantsChanged}
              displayState={nextDeliveryDisplayState}
              onRetryLoad={retryNextDeliveryLoad}
              variantsSaveSuccessKey={variantsSaveSuccessKey}
            />

            {/* クーポン */}
            <div id="coupon-section">
              <Coupon
                loading={loading}
                coupon={coupon}
                subscription={subscription!}
                setting={setting}
                clickUpdateBtnFunc={() => {
                  setLoading(true);
                  applyCoupon(
                    setting,
                    subscription!,
                    coupon,
                    () => {
                      window.parent.postMessage({ action: 'pageReload' }, '*');
                    },
                    (response) =>
                      setMessageModal({
                        message: response,
                      }),
                    () => {
                      setLoading(false);
                    }
                  );
                }}
                changeValueFunc={(value) => {
                  setCoupon(value);
                }}
                thanksmileCoupons={thanksmileCoupons}
                isAnchorLink={isCouponAnchorLink}
              />
            </div>
            {/* 利用規約 */}
            <TermsOfService
              clickLinkFunc={(type) => {
                setTermsOfServiceModal({
                  modalType: type,
                });
              }}
              clickCancellationLinkFunc={() => setCancellationSectionModal(true)}
            />
            <div className="coloredContent">
              {/* 配送先住所を変更する */}
              <ChangeDeliveryAddress
                loading={loading}
                changeDeliveryAddress={changeDeliveryAddress}
                setting={setting}
                clickUpdateBtnFunc={(valid) => {
                  if (!valid) {
                    setMessageModal({
                      message: '未入力の項目が存在します',
                    });
                    return;
                  }

                  setLoading(true);
                  updateDeliveryAddress(
                    setting,
                    subscription!,
                    changeDeliveryAddress!,
                    (deliveryData) => {
                      setSubscription({
                        ...subscription!,
                        ...deliveryData,
                      });
                      setUpdateMessageModal({
                        isSuccess: true,
                      });
                      setReloadFlg(true);
                    },
                    () =>
                      setUpdateMessageModal({
                        isSuccess: false,
                      }),
                    () => {
                      setLoading(false);
                    }
                  );
                }}
                changeValueFunc={(name, value) => changeDeliveryAddressFunc(name, value)}
              />
              {/* 支払方法を変更する */}
              <ChangePaymentMethod
                loading={loading}
                setting={setting}
                customerPaymentMethod={subscription?.customerPaymentMethod}
                clickOkBtnFunc={() => {
                  setLoading(true);
                  paymentMethodUpdate(
                    setting,
                    subscription!,
                    () =>
                      setMessageModal({
                        message: '支払い方法変更・確認のご案内メールを送信しました。',
                      }),
                    () =>
                      setMessageModal({
                        message: '支払い方法変更・確認のご案内メールを送信に失敗しました',
                      }),
                    () => {
                      setLoading(false);
                    }
                  );
                }}
              />
              {
                // 契約日がmodelChangeDate以前以降で遷移先を切り替え
                isBeforeModelChange ? (
                  <CancelPauseLink
                    cancelPauseInfo={cancelPauseInfo}
                    id={id}
                    setting={setting}
                    subscription={subscription!}
                    loading={loading}
                    toggleLoading={setLoading}
                    toggleSkipModal={setSkipModal}
                    onSwitchToRecommended={() => handleOpenRecommendSet('pause')}
                    returnToPauseModal={returnToPauseModal}
                    setReturnToPauseModal={setReturnToPauseModal}
                  />
                ) : (
                  <>
                    <PauseLink
                      cancelPauseInfo={cancelPauseInfo}
                      setting={setting}
                      subscription={subscription!}
                      loading={loading}
                      toggleLoading={setLoading}
                      toggleSkipModal={setSkipModal}
                      onSwitchToRecommended={() => handleOpenRecommendSet('pause')}
                      returnToPauseModal={returnToPauseModal}
                      setReturnToPauseModal={setReturnToPauseModal}
                    />
                  </>
                )
              }
            </div>
          </div>
          <BackBtn
            clickBackBtnFunc={() => {
              if (isVariantsChanged) {
                setIsVariantsDirty(true);
                return;
              }
              postMessageGtag('click_back_to_top_footer', 'detailSettings');
              history.push('/');
            }}
          />
        </div>
      </div>
      <SkipModal
        active={skipModal !== null}
        closeFunc={() => setSkipModal(null)}
        skipModal={skipModal}
        loading={loading}
        summary={summary}
        setting={setting}
        subscription={subscription!}
        toggleMessageModal={setUpdateMessageModal}
        toggleLoading={setLoading}
        toggleSubscription={setSubscription}
        onSwitchToRecommended={() => handleOpenRecommendSet('skip')}
      />
      {/* 商品切り替え（レコメンド）モーダル
      subscriptionがundefinedの可能性があるため、存在するときのみ */}
      {subscribedProducts && (
        <RecommendedSetModal
          active={showRecommendedSet}
          closeFunc={() => setShowRecommendedSet(false)}
          subscribed={subscribedProducts}
          onSelect={handleProductSetChange}
          showBackButton={modalOrigin !== null}
          onBackClick={handleBackToOriginalModal}
        />
      )}

      {/* お届け予定日を変更するモーダル */}
      <ChangeDeliveryDateModal
        active={changeDeliveryDateModal !== null}
        closeFunc={() => {
          setChangeDeliveryDateModal(null);
        }}
        changeDeliveryDateModal={changeDeliveryDateModal}
        isDeliveryTimeSetting={isDeliveryTimeSetting}
        loading={loading}
        route={'SubscriptionDetail'}
        changeDeliveryDateFunc={(date) => {
          setChangeDeliveryDateModal({
            ...changeDeliveryDateModal!,
            nextDeliveryDate: date,
          });
        }}
        changeDeliveryTimeFunc={(deliveryTime) => {
          setChangeDeliveryDateModal({
            ...changeDeliveryDateModal!,
            deliveryTime,
          });
        }}
        clickUpdateBtnFunc={() => {
          const errors = validUpdateDeliveryDays(subscription!);
          if (errors.length > 0) {
            setMessageModal({
              message: errors[0],
            });

            return;
          }

          setLoading(true);
          // お届け日のみ変更
          updateDeliveryDays(
            setting,
            subscription!,
            changeDeliveryDateModal!,
            (nextBillingDate, nextDeliveryDate, deliveryDays, deliveryTime, deliveryTimeText) => {
              setSubscription({
                ...subscription!,
                nextBillingDate,
                nextDeliveryDate,
                deliveryDays,
                deliveryTime,
                deliveryTimeText,
              });
              setUpdateMessageModal({
                isSuccess: true,
              });
            },
            () =>
              setUpdateMessageModal({
                isSuccess: false,
              }),
            () => {
              setLoading(false);
              setChangeDeliveryDateModal(null);
            }
          );
        }}
      />
      <ChangeDeliveryIntervalModal
        active={changeDeliveryIntervalModal !== null}
        closeFunc={() => setChangeDeliveryIntervalModal(null)}
        interval={subscription?.billingPolicyInterval}
        intervalCount={subscription?.billingPolicyIntervalCount}
        modal={changeDeliveryIntervalModal}
        loading={loading}
        clickUpdateBtnFunc={(intervalCount) => {
          // 周期変更
          setLoading(true);
          updateSubscriptionLinePlan(
            setting,
            subscription!,
            {
              billingPolicyIntervalCount: intervalCount,
              billingPolicyInterval: intervalCount === 4 ? 'WEEK' : 'DAY',
            },
            () => {
              fetchSubscription();
              setUpdateMessageModal({
                isSuccess: true,
              });
            },
            () => {
              setUpdateMessageModal({
                isSuccess: false,
              });
            },
            () => {
              setLoading(false);
              setChangeDeliveryIntervalModal(null);
            }
          );
        }}
      />
      {/* メッセージのみ表示するモーダル */}
      <MessageModal
        active={messageModal !== null}
        closeFunc={() => setMessageModal(null)}
        messageModal={messageModal}
      />
      {/* 更新処理後のメッセージを表示するモーダル */}
      <AfterUpdateMessageModal
        active={updateMessageModal !== null}
        closeFunc={() => {
          setUpdateMessageModal(null);
          if (reloadFlg) {
            setReloadFlg(false);
            window.parent.postMessage(
              {
                action: 'pageReload',
              },
              '*'
            );
          }
        }}
        updateMessageModal={updateMessageModal}
        // 一時的に「すぐに商品が必要ですか？」リンクを非表示にするため、
        // showNewOrderModal は渡さない（復活時は下記を戻す）。
        // showNewOrderModal={() => {
        //   setNewOrderModal({
        //     isOpen: true,
        //     isAfterProductUpdate: true,
        //   } as NewOrderModalType);
        // }}
        //リロードなしで閉じる
        closeWithoutReload={() => {
          setUpdateMessageModal(null);
        }}
      />
      {/* 処理に時間がかかるときに表示するモーダル */}
      <LoadingModal active={heavyLoading} />
      {/* 利用規約モーダル */}
      <TermsOfServiceModal
        active={termsOfServiceModal !== null}
        termsOfServiceModal={termsOfServiceModal}
        closeFunc={() => setTermsOfServiceModal(null)}
        loading={loading}
      />
      {/* 利用規約 停止・解約モーダル */}
      <CancellationSectionModal
        active={cancellationSectionModal}
        closeFunc={() => setCancellationSectionModal(false)}
        clickSkipFunc={() => {
          setCancellationSectionModal(false);
          setSkipModal({ isOpen: true });
        }}
      />
      {/* 商品説明モーダル */}
      <ProductDescModal
        active={productDescModal !== null}
        closeFunc={() => setProductDescModal(null)}
        productDescModal={productDescModal}
      />
      {/* 確認モーダル(最低金額以下から最低金額以上に変更した場合の注意喚起) */}
      <ConfirmModal
        active={confirmModal !== null}
        closeFunc={() => setConfirmModal(null)}
        confirmModal={confirmModal}
      />
      {/* 最短でお届けモーダル */}
      <NewOrderModal
        active={newOrderModal !== null}
        // キャンセル/バツボタン専用の閉じる処理
        closeFunc={() => {
          setNewOrderModal(null);
        }}
        // 注文確定ボタン専用の閉じる処理
        handleOrderClose={() => {
          setNewOrderModal(null); // リロードなしでモーダルを閉じる
        }}
        loading={loading}
        isAfterProductUpdate={newOrderModal?.isAfterProductUpdate}
        clickOrderBtnFunc={handleNewOrder}
        subscription={subscription}
      />
      {/* 最短でお届け後のカウントダウンモーダル */}
      <CountdownProgressModal
        active={showCountdownProgress}
        duration={20}
        onComplete={handleCountdownComplete}
        nextDeliveryMessage={
          subscription?.billingPolicyInterval === 'WEEK'
            ? `次回のお届け日を\n${subscription.billingPolicyIntervalCount}週後に変更しています。`
            : `次回のお届け日を\n${subscription?.billingPolicyIntervalCount}日後に変更しています。`
        }
      />
      <NewOrderUpdateMessageModal
        active={newOrderUpdateMessageModal != null}
        closeFunc={() => {
          setNewOrderUpdateMessageModal(null);
          // 直近のお届けを再取得するためリロード
          window.parent.postMessage({ action: 'pageReload' }, '*');
        }}
        newOrderUpdateMessageModal={newOrderUpdateMessageModal}
      />
      <ConfirmVariantsDirtyModal
        active={isVariantsDirty}
        closeFunc={() => setIsVariantsDirty(false)}
        clickLeavePageBtnFunc={() => {
          history.push('/');
        }}
      />
    </>
  );
};
